module.exports = __webpack_public_path__ + "static/img/tradejiugonge.0c6dc80b.png";